<template>
  <div class="mt-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <div class="card">
            <div class="d-flex">
              <h3 class="font-weight-light ml-3 mr-auto">Pagamento de FGTS</h3>
              <WhiteLabel class="ml-auto mt-1 pull-right mr-4">
                <router-link :to="{ name: 'bills-payment' }">
                  <i class="icon-arrow-left-circle"></i> Voltar
                </router-link>
              </WhiteLabel>
            </div>
            <hr />
            <div class="card-content">
              <div class="form-row col-12">
                <div class="col-12 col-w-full">
                  <WhiteLabel>
                    <h4 class="font-weight-light blue">
                      {{ getTitle() }}
                    </h4>
                  </WhiteLabel>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Agência</label>
                  <p>{{ paymentDetail.preset.bankAccount.bankBranchNumber }}</p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Conta</label>
                  <p>{{ paymentDetail.preset.bankAccount.accountNumber }}</p>
                </div>

                <div class="form-group col-12 col-lg-12 mb-4">
                  <label>Nome</label>
                  <p>{{ paymentDetail.preset.holder.fullName }}</p>
                </div>

                <div class="form-group col-12 col-lg-12 mb-4">
                  <label>Código de barras</label>
                  <p>{{ formatStringInFourParts(paymentDetail.barCode) }}</p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>CNPJ</label>
                  <p>{{ getValueOf('AgreementDocument') }}</p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label> Código do convênio </label>
                  <p>{{ getValueOf('AgreementCode') }}</p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Data de validade</label>
                  <p>{{ paymentDetail.dueDate | moment('DD/MM/YYYY') }}</p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Identificador</label>
                  <p>{{ getValueOf('Identifier') }}</p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Competência</label>
                  <p>{{ getValueOf('CompetencePeriod') }}</p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Valor recolhido</label>
                  <p>
                    {{
                      paymentDetail.valuePaid
                        | currency('R$ ', 2, {
                          decimalSeparator: ',',
                          thousandsSeparator: '.',
                        })
                    }}
                  </p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Descrição do pagamento</label>
                  <p>{{ getValueOf('Description') || 'FGTS' }}</p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Código da operação</label>
                  <p>{{ getValueOf('OperationCode') }}</p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Data e hora do pagamento</label>
                  <p>{{ paymentDetail.createdAt | moment('DD/MM/YYYY HH:mm:ss') }}</p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Via</label>
                  <p>Internet</p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>CTRL</label>
                  <p>{{ getValueOf('ControlNumber') }}</p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>NSU</label>
                  <p>{{ getValueOf('Nsu') }}</p>
                </div>

                <div class="form-group col-12">
                  <label class="text-muted">
                    RECEBIDO POR CORRESPONDENTE BANCÁRIO DIGITAL E PROCESSADO POR ITAÚ UNIBANCO S.A.
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paymentDetailsCommonMethods from './paymentDetailsCommonMethods.js';

export default {
  methods: {
    getTitle() {
      const agreementCode = this.getAgreementCode();
      if (
        agreementCode == '0451' ||
        agreementCode == '0180' ||
        agreementCode == '0179'
      )
        return 'Comprovante de Pagamento com código de barras - GRFGTS - Guia de Recolhimento do FGTS';
      if (agreementCode == '0240')
        return 'Comprovante de Pagamento com código de barras - GRDE - Guia de Recolhimento de Débitos do FGTS';
      if (agreementCode == '0239')
        return 'Comprovante de Pagamento com código de barras - GRRF - Guia de Recolhimento Rescisório do FGTS';

      return '';
    },
  },
  name: 'AppPaymentDetailsTypeFGTS',
  mixins: [paymentDetailsCommonMethods],
  props: {
    paymentDetail: {
      type: Object,
      required: true,
      validator(value) {
        return (
          value &&
          typeof value.barCode === 'string' &&
          'valuePaid' in value &&
          'preset' in value
        );
      },
    },
  },
};
</script>
